module.exports = __webpack_public_path__ + "static/media/schedule_demo.f0bfd02c.png";